import { Popup } from '@paywithextend/components'
import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import useAnalyticsContext from 'src/analytics/useAnalyticsContext'
import { selectVirtualCardIdFromRoute } from 'src/app/UpdateVirtualCardForm/redux/updateVirtualCardForm.selectors'
import { ButtonDesigns } from 'src/components/Button/Button'
import ConfirmationPopupContent from 'src/components/ConfirmationPopupContent/ConfirmationPopupContent'
import { useTranslate } from 'src/localization/Trns'
import { closeModal, connectedPush } from 'src/navigation/Lnk'
import { virtualCardDetailUrl } from 'src/navigation/urls'
import { createSetIsRequestCompletedPopupOpen } from 'src/redux/actions/app.actions'
import { createSetVirtualCardFailure } from 'src/redux/actions/data/virtualCards.actions'

const RequestCompletedPopup: React.FC = (): React.ReactElement => {
  const translate = useTranslate()

  const dispatch = useDispatch()
  const virtualCardId = useSelector(selectVirtualCardIdFromRoute)
  const { analytics } = useAnalyticsContext()

  const dispatchOpenVCNDetail = (): void => {
    dispatch(createSetVirtualCardFailure())
    dispatch(connectedPush(virtualCardDetailUrl(virtualCardId)))
    dispatch(createSetIsRequestCompletedPopupOpen(false))
  }

  const closePopup = (sendEvent?: boolean): void => {
    dispatch(createSetVirtualCardFailure())
    dispatch(createSetIsRequestCompletedPopupOpen(false))
    dispatch(closeModal())
    if (sendEvent) {
      analytics?.track('request completed modal - close', {
        interaction: 'button press',
        intent: 'close modal',
        screen: 'request completed modal',
      })
    }
  }

  return (
    <Popup
      onClickClose={closePopup}
      showCloseButton
      css={`
        display: flex;
        flex-direction: column;
        position: relative;
      `}
    >
      <ConfirmationPopupContent
        title={translate('Request already completed')}
        subtitle={
          <p>
            {translate(
              'Virtual card update request has already been approved or declined by a budget user',
            )}
          </p>
        }
        actionButtonLabel={translate('Review Virtual Card')}
        actionButtonOnClick={(): void => {
          dispatchOpenVCNDetail()
          analytics?.track('request completed modal - review virtual card', {
            interaction: 'button press',
            intent: 'review virtual card',
            screen: 'request completed modal',
          })
        }}
        actionButtonLoading={undefined}
        actionButtonDesign={ButtonDesigns.designCta}
        isCancelButtonLink
        underline={false}
        cancelButtonOnClick={(): void => closePopup(true)}
        cancelButtonLabel={translate('Close')}
      />
    </Popup>
  )
}

export default RequestCompletedPopup
